import 'react';
import classes from './SkeletonText.module.css.js';
import { clsx } from 'clsx';
import '@styled-system/css';
import merge from 'deepmerge';
import { SkeletonBox } from '../../Skeleton/SkeletonBox.js';
import { jsx } from 'react/jsx-runtime';

const SkeletonText = ({
  lines = 1,
  maxWidth,
  size = 'bodyMedium',
  className,
  style,
  ...rest
}) => {
  if (lines < 2) {
    return /*#__PURE__*/jsx(SkeletonBox, {
      "data-component": "SkeletonText",
      "data-text-skeleton-size": size,
      width: "100%",
      className: clsx(className, classes.SkeletonText),
      style: merge(style, {
        maxWidth
      }),
      ...rest
    });
  } else {
    return /*#__PURE__*/jsx("div", {
      "data-component": "multilineContainer",
      className: classes.SkeletonTextWrapper,
      style: merge(style, {
        maxWidth
      }),
      children: Array.from({
        length: lines
      }, (_, index) => /*#__PURE__*/jsx(SkeletonBox, {
        "data-component": "SkeletonText",
        "data-in-multiline": "true",
        "data-text-skeleton-size": size,
        className: clsx(className, classes.SkeletonText),
        ...rest
      }, index))
    });
  }
};

export { SkeletonText };
